<template>
  <div class="main editApplicationMain">
    <!-- 顶部 -->
    <div class="title">
      <img src="../assets/back.png" class="back" @click="goBack" />
      <span class="text">修改申请表</span>
    </div>

    <!-- 下部分 -->
    <div class="whiteBackground">
      <!-- 标题 -->
      <div class="headling">
        <span>上海市绿色建筑协会会员申请表</span>
      </div>
      <!-- 基本信息 -->
      <div class="part1">
        <img src="../assets/message.png" />
        <span class="caption">基本信息</span>
      </div>
      <div class="part2">
        <el-form :label-position="labelPosition" label-width="140px" size="small">
          <el-row :gutter="80">
            <el-col :span="11">
              <el-form-item label="单位名称（中文）:" required>
                <el-input v-model="infoData.companyname" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="单位名称（英文）:" required>
                <el-input v-model="infoData.companyname1" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80">
            <el-col :span="11">
              <el-form-item label="联系地址:" required>
                <el-input v-model="infoData.address" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="邮编:" required>
                <el-input v-model="infoData.postcode" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80">
            <el-col :span="11">
              <el-form-item label="公司网址:" required>
                <el-input v-model="infoData.website" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="推荐单位:" required>
                <el-input v-model="infoData.recommendcompany" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="所在行政区:">
                <el-select v-model="infoData.administrativeregion" filterable>
                  <el-option
                    v-for="(item, index) in options"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <span style="color: #f00;font-size: 14px;">仅限联系地址为上海的单位选择</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="单位简介:" required>
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 6}"
              v-model="infoData.introduction"
            ></el-input>
          </el-form-item>
          <el-form-item label="简介附件:" required>
            <el-button type="primary" size="medium" @click="uploadFiles">选择文件</el-button>
            <input
              type="file"
              hidden
              ref="chooseFiles"
              @change="handleChange"
              accept=".doc, .docx, .pdf"
            />
            <p>
              <span v-if="!fileUrl">{{infoData.fileid && infoData.fileid.name}}</span>
              <a v-if="fileUrl" :href="downloadUrl + fileUrl" target="_blank">{{fileNAME}}</a>
            </p>
            <div
              style="font-size:14px;"
            >简介附件要求:&nbsp;&nbsp;(doc/docx文件)，文字1500字以上，配3张以上精度较高的图片</div>
            <div style="color: #f00;">文件大小不得超过50MB</div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 企业类型 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/enterprise.png" />
          <span class="caption">企业类型</span>
        </div>
        <div class="part2">
          <el-form>
            <el-form-item>
              <el-radio-group v-model="infoData.ownershipoption">
                <el-radio label="-24776">国企</el-radio>
                <el-radio label="-24777">私企</el-radio>
                <el-radio label="-24781">港外合资</el-radio>
                <el-radio label="-24778">外资独资</el-radio>
                <el-radio label="-24782">事业</el-radio>
                <el-radio label="-24779">合资</el-radio>
                <el-radio label="-24783">院校</el-radio>
                <el-radio label="-24780">政府</el-radio>
                <el-radio label="-24784">其他</el-radio>
                <el-input
                  :disabled="+infoData.ownershipoption !== -24784"
                  v-model="infoData.ownershipother"
                  class="input-200"
                  size="small"
                ></el-input>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 企业规模 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/calculate.png" />
          <span class="caption">企业规模</span>
        </div>
        <div class="part2">
          <el-form>
            <el-form-item>
              <el-radio-group v-model="infoData.scaleoption">
                <el-radio label="-24798">大型企业</el-radio>
                <el-radio label="-24799">中型企业</el-radio>
                <el-radio label="-24800">小型企业</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 是否上市公司 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/public_company.png" />
          <span class="caption">是否上市</span>
        </div>
        <div class="part2">
          <el-form>
            <el-form-item>
              <el-radio-group v-model="infoData.public_company">
                <el-radio label="-25001">是上市企业</el-radio>
                <el-radio label="-25002">不是上市企业</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 主营业务 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/business.png" />
          <span class="caption">主营业务</span>
        </div>
        <div class="part2">
          <el-form>
            <el-form-item>
              <el-checkbox-group v-model="infoData.businessnatureoption">
                <el-checkbox
                  label="-24786"
                  :class="+infoData.businessnatureoption[0] === -24786 ? 'red' : ''"
                >设计规划</el-checkbox>
                <el-checkbox
                  label="-24792"
                  :class="+infoData.businessnatureoption[0] === -24792 ? 'red' : ''"
                >建筑材料</el-checkbox>
                <el-checkbox
                  label="-24787"
                  :class="+infoData.businessnatureoption[0] === -24787 ? 'red' : ''"
                >咨询管理</el-checkbox>
                <el-checkbox
                  label="-24793"
                  :class="+infoData.businessnatureoption[0] === -24793 ? 'red' : ''"
                >设备/产品</el-checkbox>
                <el-checkbox
                  label="-24788"
                  :class="+infoData.businessnatureoption[0] === -24788 ? 'red' : ''"
                >开发商</el-checkbox>
                <el-checkbox
                  label="-24794"
                  :class="+infoData.businessnatureoption[0] === -24794 ? 'red' : ''"
                >运行/维护</el-checkbox>
                <el-checkbox
                  label="-24789"
                  :class="+infoData.businessnatureoption[0] === -24789 ? 'red' : ''"
                >总承包商</el-checkbox>
                <el-checkbox
                  label="-24795"
                  :class="+infoData.businessnatureoption[0] === -24795 ? 'red' : ''"
                >软件/平台</el-checkbox>
                <el-checkbox
                  label="-24790"
                  :class="+infoData.businessnatureoption[0] === -24790 ? 'red' : ''"
                >专业施工</el-checkbox>
                <el-checkbox
                  label="-24791"
                  :class="+infoData.businessnatureoption[0] === -24791 ? 'red' : ''"
                >科研院校</el-checkbox>
                <el-checkbox
                  label="-24796"
                  :class="+infoData.businessnatureoption[0] === -24796 ? 'red' : ''"
                >其他</el-checkbox>
                <el-input
                  :disabled="+infoData.businessnatureoption !== -24796"
                  v-model="infoData.businessnatureother"
                  class="input-200"
                  size="small"
                ></el-input>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 会员代表 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/memeber.png" />
          <span class="caption">会员代表（会员代表建议为贵司主要领导或分管负责人）</span>
        </div>
        <div class="part2">
          <el-form :label-position="labelPosition" label-width="140px" size="small">
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="姓名（中文）:" required>
                  <el-input v-model="infoData.representativename" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="姓名（英文）:" required>
                  <el-input v-model="infoData.representativename1" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="性别:" required>
                  <el-input v-model="infoData.gender" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="职务:" required>
                  <el-input v-model="infoData.representativeposition" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="电话:" required>
                  <el-input v-model="infoData.representativetel" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="手机:" required>
                  <el-input v-model="infoData.representativephone" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="电邮:" required>
                  <el-input v-model="infoData.representativeemail" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="传真:" required>
                  <el-input v-model="infoData.representativetax" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="身份证号:" required>
                  <el-input v-model="infoData.idcard" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="政治面貌:" required>
                  <el-input v-model="infoData.politicsstatus" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11">
                <el-form-item label="是否离退:" required>
                  <el-radio-group v-model="infoData.ismembership">
                    <el-radio label="是"></el-radio>
                    <el-radio label="否"></el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <!-- 联系人 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/linkman.png" />
          <span class="caption">联系人（联系人为贵司与协会日常沟通人员）</span>
        </div>
        <div class="part2">
          <el-form :label-position="labelPosition" label-width="140px" size="small">
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="姓名（中文）:" required>
                  <el-input v-model="infoData.contactpersoncontactname" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="姓名（英文）:" required>
                  <el-input v-model="infoData.contactpersoncontactname1" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="职务:" required>
                  <el-input v-model="infoData.contactpersonposition" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="电邮:" required>
                  <el-input v-model="infoData.contactpersonemail" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="手机:" required>
                  <el-input v-model="infoData.contactpersonphone" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="电话:" required>
                  <el-input v-model="infoData.contactpersontel" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="传真:" required>
                  <el-input v-model="infoData.contactpersonfax" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="联系地址:" required>
                  <el-input v-model="infoData.contactpersonaddress" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="邮编:" required>
                  <el-input v-model="infoData.contactpersonpostcode" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <!-- 党建工作 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/poverty.png" />
          <span class="caption">党建工作</span>
        </div>
        <div class="part2">
          <el-form :label-position="labelPosition" label-width="140px" size="small">
            <el-row style="margin-left: -140px;">
              <el-form-item>
                <el-radio-group v-model="infoData.partyoption">
                  <el-radio label="-24802">党委</el-radio>
                  <el-radio label="-24825">党总支</el-radio>
                  <el-radio label="-24803">党支部</el-radio>
                  <el-radio label="-24826">联合党支部</el-radio>
                  <el-radio label="-24827">党的工作小组</el-radio>
                  <el-radio label="-24804">未建立党组织</el-radio>
                  <!-- <el-input
                    :disabled="+infoData.partyoption !== -24804"
                    v-model="infoData.partyremark"
                    class="input-200"
                    size="small"
                  ></el-input> -->
                </el-radio-group>
              </el-form-item>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="成立时间:" required>
                  <el-date-picker
                    v-model="infoData.partyestablishtime"
                    type="date"
                    size="small"
                    clearable
                    :disabled="+infoData.partyoption === -24804"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="党员人数:" required>
                  <el-input
                    v-model="infoData.partymembernumber"
                    clearable
                    size="small"
                    :disabled="+infoData.partyoption === -24804"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="党建联系人:" required>
                  <el-input
                    v-model="infoData.partylinkman"
                    clearable
                    :disabled="+infoData.partyoption === -24804"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="职务:" required>
                  <el-input
                    v-model="infoData.partyposition"
                    clearable
                    :disabled="+infoData.partyoption === -24804"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="手机:" required>
                  <el-input
                    v-model="infoData.partyphone"
                    clearable
                    :disabled="+infoData.partyoption === -24804"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="电话:" required>
                  <el-input
                    v-model="infoData.partytel"
                    clearable
                    :disabled="+infoData.partyoption === -24804"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="邮箱:" required>
                  <el-input
                    v-model="infoData.partyemail"
                    clearable
                    :disabled="+infoData.partyoption === -24804"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="其他情况说明:">
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 6}"
                v-model="infoData.partyother"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 声明 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/statement.png" />
          <span class="caption">声明</span>
        </div>
        <div class="part2">
          <el-form>
            <div class="promiss">
              <p class="promiss-text">本单位自愿加入上海市绿色建筑协会，遵守协会章程，并积极参与协会各项活动。</p>
            </div>
            <div class="box">
              <div class="box-item">
                <div class="text">单位盖章:</div>
                <input disabled class="smallInput" style="visibility: hidden;" />
              </div>
              <div class="box-item">
                <div class="text">法人代表:</div>
                <input disabled class="smallInput" v-model="infoData.statementrepresentative" />
              </div>
              <div class="box-item">
                <div class="text">日期:</div>
                <input disabled class="smallInput" v-model="infoData.statementdate" />
              </div>
            </div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="审核意见:" required style="margin-left:100px;">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 6}"
                    v-model="infoData.partyother"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="box">
              <div class="box-item">
                <div class="text">签字:</div>
                <input disabled class="smallInput" v-model="infoData.statementsignature" />
              </div>
              <div class="box-item">
                <div class="text">日期:</div>
                <input disabled class="smallInput" v-model="infoData.statementauditdate" />
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="btns">
        <!-- <el-button type="primary" @click="tempSave">暂存</el-button> -->
        <el-button type="primary" @click="submit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as Cache from '../utils/cache'
import * as API from '../utils/apiService'
import config from '../config'
import moment from 'moment'

export default {
  data () {
    return {
      downloadUrl: config.downloadUrl,
      fileUrl: '',
      fileNAME: '',
      labelPosition: 'right', // label对齐方式
      infoData: {
        // 基本信息
        companyname: '', // 单位名称（中文）
        companyname1: '', // 单位名称（英文）
        address: '', // 联系地址
        administrativeregion: '', // 所在行政区
        website: '', // 公司网址
        postcode: '', // 邮编
        recommendcompany: '', // 推荐单位
        introduction: '', // 单位简介
        fileid: '', // 单位简介附件
        // 企业类型
        ownershipoption: '', // 企业类型
        ownershipother: '', // 企业类型备注
        // 企业规模
        scaleoption: '', // 企业规模
        // 上市公司
        public_company: '', // 上市公司
        // 主营业务
        businessnatureoption: [], // 主营业务
        businessnatureother: '', // 主营业务备注
        // 会员代表
        representativename: '', // 姓名（中文）
        representativename1: '', // 姓名（英文）
        gender: '', // 性别
        representativeposition: '', // 职务
        representativetel: '', // 电话
        representativephone: '', // 手机
        representativeemail: '', // 电邮
        representativetax: '', // 传真
        idcard: '', // 身份证号
        politicsstatus: '', // 政治面貌
        ismembership: '', // 是否离退
        // 联系人
        contactpersoncontactname: '', // 姓名(中文)
        contactpersoncontactname1: '', // 姓名(英文)
        contactpersonposition: '', // 职务
        contactpersonemail: '', // 电邮
        contactpersonphone: '', // 手机
        contactpersontel: '', // 电话
        contactpersonfax: '', // 传真
        contactpersonaddress: '', // 联系地址
        contactpersonpostcode: '', // 邮编
        // 党建工作
        partyoption: '', // 党建工作
        // partyremark: '', // 党建工作备注
        partyestablishtime: '', // 成立时间
        partymembernumber: '', // 党员人数
        partylinkman: '', // 党建联系人
        partyposition: '', // 党建职务
        partyphone: '', // 党建手机
        partytel: '', // 党建电话
        partyemail: '', // 党建邮箱
        partyother: '', // 党建其他情况说明
        // 声明
        statementrepresentative: '', // 法人代表签字
        statementdate: '', // 日期
        statementauditopinion: '', // 审核意见
        statementsignature: '', // 签字
        statementauditdate: '' // 日期
      },
      options: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 'HP',
          label: '黄浦区'
        },
        {
          value: 'XH',
          label: '徐汇区'
        },
        {
          value: 'CN',
          label: '长宁区'
        },
        {
          value: 'JA',
          label: '静安区'
        },
        {
          value: 'PT',
          label: '普陀区'
        },
        {
          value: 'HK',
          label: '虹口区'
        },
        {
          value: 'YP',
          label: '杨浦区'
        },
        {
          value: 'MH',
          label: '闵行区'
        },
        {
          value: 'BS',
          label: '宝山区'
        },
        {
          value: 'JD',
          label: '嘉定区'
        },
        {
          value: 'PD',
          label: '浦东新区'
        },
        {
          value: 'JS',
          label: '金山区'
        },
        {
          value: 'SJ',
          label: '松江区'
        },
        {
          value: 'QP',
          label: '青浦区'
        },
        {
          value: 'FX',
          label: '奉贤区'
        }
      ],
      backShowData: false // 是否有回显数据
    }
  },
  mounted () {
    this.asyncFindOneInfo()
  },
  watch: {
    'infoData.businessnatureoption' (val, oldVal) {
      if (!this.backShowData) {
        if (oldVal.length === 0 && val.length === 1) {
          let r = []
          this.$confirm('是否将此业务类型作为主营业务？', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          })
            .then(v => {
              r.push(val[0])
              this.infoData.businessnatureoption = r
              this.$message.success('成功设为主营业务')
            })
            .catch(v => {
              r = []
              this.infoData.businessnatureoption = r
            })
        }
      } else {
        this.backShowData = false
      }
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    asyncFindOneInfo () {
      let params = {
        userid: Cache.getUserInfo().id
      }
      return API.findOneInfo(params).then(resp => {
        if (resp.resultCode === '0000') {
          if (resp.data) {
            this.backShowData = true
            const businessnatureoption = resp.data.businessnatureoption
            if (businessnatureoption === 'false' || businessnatureoption === '') {
              resp.data.businessnatureoption = []
            } else {
              resp.data.businessnatureoption = businessnatureoption.split(',')
            }
            this.infoData = resp.data
            this.fileUrl = resp.data.file
            let newFileUrl = this.fileUrl.split('/')
            this.fileNAME = newFileUrl[newFileUrl.length - 1]
          }
        }
        return resp
      })
    },
    uploadFiles () {
      this.$refs.chooseFiles.click()
    },
    // 文件改变时触发
    handleChange (e) {
      let fileSize = e.target.files[0].size / 1024 / 1024
      if (fileSize > 25) {
        this.$message.error('文件大小不能超过50M！')
        return false
      }
      this.infoData.fileid = e.target.files[0]
      this.fileNAME = e.target.files[0].name
      this.$refs.chooseFiles.value = null
      this.fileUrl = this.getFileURL(this.infoData.fileid)
      return e
    },
    // 获取文件路径
    getFileURL (file) {
      let url = null
      if (file) {
        if (window.createObjectURL !== undefined) {
          // basic
          url = window.createObjectURL(file)
        } else if (window.URL !== undefined) {
          // mozilla(firefox)
          url = window.URL.createObjectURL(file)
        } else if (window.webkitURL !== undefined) {
          // webkit or chrome
          url = window.webkitURL.createObjectURL(file)
        }
      }
      return url
    },
    // 存放参数
    saveParams () {
      return {
        companyname: this.infoData.companyname,
        companyname1: this.infoData.companyname1,
        address: this.infoData.address,
        administrativeregion: this.infoData.administrativeregion,
        website: this.infoData.website,
        postcode: this.infoData.postcode,
        recommendcompany: this.infoData.recommendcompany,
        introduction: this.infoData.introduction,
        ownershipoption: this.infoData.ownershipoption,
        ownershipother: this.infoData.ownershipother,
        scaleoption: this.infoData.scaleoption,
        public_company: this.infoData.public_company,
        businessnatureoption: this.infoData.businessnatureoption,
        businessnatureother: this.infoData.businessnatureother,
        representativename: this.infoData.representativename,
        representativename1: this.infoData.representativename1,
        gender: this.infoData.gender,
        representativeposition: this.infoData.representativeposition,
        representativetel: this.infoData.representativetel,
        representativephone: this.infoData.representativephone,
        representativeemail: this.infoData.representativeemail,
        representativetax: this.infoData.representativetax,
        idcard: this.infoData.idcard,
        politicsstatus: this.infoData.politicsstatus,
        ismembership: this.infoData.ismembership,
        contactpersoncontactname: this.infoData.contactpersoncontactname,
        contactpersoncontactname1: this.infoData.contactpersoncontactname1,
        contactpersonposition: this.infoData.contactpersonposition,
        contactpersonemail: this.infoData.contactpersonemail,
        contactpersonphone: this.infoData.contactpersonphone,
        contactpersontel: this.infoData.contactpersontel,
        contactpersonfax: this.infoData.contactpersonfax,
        contactpersonaddress: this.infoData.contactpersonaddress,
        contactpersonpostcode: this.infoData.contactpersonpostcode,
        partyoption: this.infoData.partyoption,
        partyremark: '',
        partyestablishtime: moment(this.infoData.partyestablishtime).format('YYYY-MM-DD'),
        partymembernumber: this.infoData.partymembernumber,
        partylinkman: this.infoData.partylinkman,
        partyposition: this.infoData.partyposition,
        partyphone: this.infoData.partyphone,
        partytel: this.infoData.partytel,
        partyemail: this.infoData.partyemail,
        partyother: this.infoData.partyother,
        fileid: this.infoData.fileid,
        userid: Cache.getUserInfo().id
      }
    },
    // 暂存
    tempSave () {
      let params = this.saveParams()
      API.temporaryStorage(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.$message.success('暂存成功')
          this.asyncFindOneInfo()
        } else {
          this.$message.error(resp.resultMsg)
        }
      })
    },
    // 立即申请
    submit () {
      // 基本信息类
      if (!this.infoData.companyname) {
        this.$message.error('请输入基本信息-单位名称(中文)')
        return
      }
      if (!this.infoData.companyname1) {
        this.$message.error('请输入基本信息-单位名称(英文)')
        return
      }
      if (!this.infoData.address) {
        this.$message.error('请输入基本信息-联系地址')
        return
      }
      if (!this.infoData.postcode) {
        this.$message.error('请输入基本信息-邮编')
        return
      }
      if (!this.infoData.website) {
        this.$message.error('请输入基本信息-公司网址')
        return
      }
      if (!this.infoData.recommendcompany) {
        this.$message.error('请输入基本信息-推荐单位')
        return
      }
      // if (!this.infoData.administrativeregion) {
      //   this.$message.error('请选择基本信息-所在行政区')
      //   return
      // }
      if (!this.infoData.introduction) {
        this.$message.error('请输入基本信息-单位简介')
        return
      }
      if (!this.fileUrl) {
        this.$message.error('请选择基本信息-简介附件')
        return
      }
      // 企业类型
      if (!this.infoData.ownershipoption) {
        this.$message.error('请选择企业类型')
        return
      }
      if (
        this.infoData.ownershipoption === '-24784' &&
        !this.infoData.ownershipother
      ) {
        this.$message.error('请输入企业类型-其他类型说明')
        return
      }
      // 企业规模
      if (!this.infoData.scaleoption) {
        this.$message.error('请选择企业规模')
        return
      }
      // 上市公司
      if (!this.infoData.public_company) {
        this.$message.error('请选择上市公司')
        return
      }
      // 主营业务
      if (!this.infoData.businessnatureoption) {
        this.$message.error('请选择主营业务')
        return
      }
      if (
        this.infoData.businessnatureoption === '-24796' &&
        !this.infoData.businessnatureother
      ) {
        this.$message.error('请输入主营业务-其他情况说明')
        return
      }
      // 会员代表
      if (!this.infoData.representativename) {
        this.$message.error('请输入会员代表-姓名(中文)')
        return
      }
      if (!this.infoData.representativename1) {
        this.$message.error('请输入会员代表-姓名(英文)')
        return
      }
      if (!this.infoData.gender) {
        this.$message.error('请输入会员代表-性别')
        return
      }
      if (!this.infoData.representativeposition) {
        this.$message.error('请输入会员代表-职务')
        return
      }
      if (!this.infoData.representativetel) {
        this.$message.error('请输入会员代表-电话')
        return
      }
      if (!this.infoData.representativephone) {
        this.$message.error('请输入会员代表-手机')
        return
      }
      if (!this.infoData.representativeemail) {
        this.$message.error('请输入会员代表-电邮')
        return
      }
      if (!this.infoData.representativetax) {
        this.$message.error('请输入会员代表-传真')
        return
      }
      if (!this.infoData.idcard) {
        this.$message.error('请输入会员代表-身份证号')
        return
      }
      if (!this.infoData.politicsstatus) {
        this.$message.error('请输入会员代表-政治面貌')
        return
      }
      if (!this.infoData.ismembership) {
        this.$message.error('请选择会员代表-是否离退')
        return
      }
      // 联系人
      if (!this.infoData.contactpersoncontactname) {
        this.$message.error('请输入联系人-姓名(中文)')
        return
      }
      if (!this.infoData.contactpersoncontactname1) {
        this.$message.error('请输入联系人-姓名(英文)')
        return
      }
      if (!this.infoData.contactpersonposition) {
        this.$message.error('请输入联系人-职务')
        return
      }
      if (!this.infoData.contactpersonemail) {
        this.$message.error('请输入联系人-电邮')
        return
      }
      if (!this.infoData.contactpersonphone) {
        this.$message.error('请输入联系人-手机')
        return
      }
      if (!this.infoData.contactpersontel) {
        this.$message.error('请输入联系人-电话')
        return
      }
      if (!this.infoData.contactpersonfax) {
        this.$message.error('请输入联系人-传真')
        return
      }
      if (!this.infoData.contactpersonaddress) {
        this.$message.error('请输入联系人-联系地址')
        return
      }
      if (!this.infoData.contactpersonpostcode) {
        this.$message.error('请输入联系人-邮编')
        return
      }
      // 党建工作
      if (!this.infoData.partyoption) {
        this.$message.error('请选择党建工作')
        return
      } else {
        if (this.infoData.partyoption !== '-24804') {
          if (!this.infoData.partyestablishtime) {
            this.$message.error('请输入党建工作-成立时间')
            return
          }
          if (!this.infoData.partymembernumber) {
            this.$message.error('请输入党建工作-党员人数')
            return
          }
          if (!this.infoData.partylinkman) {
            this.$message.error('请输入党建工作-党建联系人')
            return
          }
          if (!this.infoData.partyposition) {
            this.$message.error('请输入党建工作-职务')
            return
          }
          if (!this.infoData.partyphone) {
            this.$message.error('请输入党建工作-手机')
            return
          }
          if (!this.infoData.partytel) {
            this.$message.error('请输入党建工作-电话')
            return
          }
          if (!this.infoData.partyemail) {
            this.$message.error('请输入党建工作-邮箱')
            return
          }
          // if (!this.infoData.partyother) {
          //   this.$message.error('请输入党建工作-其他情况说明')
          //   return
          // }
        }
      }
      // 格式验证
      let phoneReg = /^1[3456789]\d{9}$/
      let telReg = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/
      let emailReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
      if (
        this.infoData.representativephone &&
        !phoneReg.test(this.infoData.representativephone)
      ) {
        this.$message.error('会员代表-手机格式错误')
        return
      }
      if (
        this.infoData.representativetel &&
        !telReg.test(this.infoData.representativetel)
      ) {
        this.$message.error('会员代表-电话格式错误')
        return
      }
      if (
        this.infoData.representativeemail &&
        !emailReg.test(this.infoData.representativeemail)
      ) {
        this.$message.error('会员代表-电邮格式错误')
        return
      }
      if (
        this.infoData.contactpersonphone &&
        !phoneReg.test(this.infoData.contactpersonphone)
      ) {
        this.$message.error('联系人-手机格式错误')
        return
      }
      if (
        this.infoData.contactpersontel &&
        !telReg.test(this.infoData.contactpersontel)
      ) {
        this.$message.error('联系人-电话格式错误')
        return
      }
      if (
        this.infoData.contactpersonemail &&
        !emailReg.test(this.infoData.contactpersonemail)
      ) {
        this.$message.error('联系人-电邮格式错误')
        return
      }
      if (
        this.infoData.partyphone &&
        !phoneReg.test(this.infoData.partyphone)
      ) {
        this.$message.error('党建工作-手机格式错误')
        return
      }
      if (this.infoData.partytel && !telReg.test(this.infoData.partytel)) {
        this.$message.error('党建工作-电话格式错误')
        return
      }
      if (
        this.infoData.partyemail &&
        !emailReg.test(this.infoData.partyemail)
      ) {
        this.$message.error('党建工作-邮箱格式错误')
        return
      }
      let params = this.saveParams()
      if (!params.fileid) {
        delete params.fileid
      }
      API.create(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.$message.success('提交成功')
          this.asyncFindOneInfo().then(_resp => {
            if (_resp.data) {
              if (!_resp.data.memberno) {
                if (_resp.data.status === '0') {
                  this.$router.push('/progress')
                }
              } else {
                if (_resp.data.status === '0') {
                  this.$router.go(-1)
                }
              }
            }
          })
        } else {
          this.$message.error(resp.resultMsg)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.applicationInfoMain {
  .title {
    display: flex;
    align-items: center;
    .blueCircle {
      vertical-align: middle;
      width: 30px;
      height: 30px;
    }
    .text {
      margin-left: 0;
      color: #3778ff;
    }
  }
  .whiteBackground {
    width: calc(100% - 10px);
    background: #fff;
    .headling {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0 0 0;
      height: 80px;
      span {
        font-size: 22px;
        font-weight: 550;
        color: #444;
      }
    }
    .el-input {
      width: 100%;
    }
    .el-textarea {
      width: 70%;
    }
    .el-select {
      width: 100%;
      padding-right: 40px;
    }
    .el-input__inner {
      font-size: 16px !important;
    }
    .part {
      margin-top: 30px;
    }
    .btns {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 30px;
    }
    .part1 {
      display: flex;
      align-items: center;
      width: 96%;
      margin-left: 2%;
      height: 40px;
      border-bottom: 1px solid #e3e3e3;
      img {
        width: 24px;
      }
      .caption {
        margin-left: 10px;
        font-size: 18px;
        font-weight: 550;
        color: #555;
      }
    }
    .part2 {
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
      line-height: 23px;
      margin-top: 40px;
      color: rgba(102, 102, 102, 1);
      .red span {
        color: #f00 !important;
      }
      input {
        font-size: 18px;
      }
      .input-200 {
        width: 200px;
      }
      .promiss {
        height: 90px;
        display: flex;
        justify-content: center;
        align-items: center;
        .promiss-text {
          border-bottom: 1px solid #e3e3e3;
          height: 90px;
        }
      }
      .box {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin-top: 30px;
        margin-bottom: 30px;
        .box-item {
          height: 35px;
          line-height: 35px;
          .text {
            width: 70px;
            white-space: nowrap;
            text-align: right;
            color: #666;
            font-size: 16px;
            font-weight: normal;
            float: left;
          }
          .line {
            float: right;
            width: 70%;
            border-bottom: 1px solid #e3e3e3;
          }
        }
      }
    }
  }
  .smallInput {
    width: 200px !important;
    border: 0;
    border-bottom: 1px solid #ccc;
    outline: none;
  }
}
</style>
